module.exports = __webpack_public_path__ + "europa-20_portrait_window.jpg?827f0d71c9207efc5651008ac71adda9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-20_portrait_window.jpg
// module id = 337
// module chunks = 0